export enum ReferenceType {
  Manager = 'Manager',
  Peer = 'Peer',
  Subordinate = 'Subordinate',
  Educator = 'Educator',
  Other = 'Other'
}
